import { requestApi, API_END_POINT } from '../../common/api';
import { RESULT_CODE } from '../../common/const';
import { ERROR } from '../../common/message';

/**
 * エラータイプ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SYSTEM_ERROR_TYPE = 'COMMON/SET_SYSTEM_ERROR_TYPE';

/**
 * エラータイプ設定
 * @param   {string}  errorType  エラータイプ
 */
export const setSystemErrorType = (errorType) => ({
  type: SET_SYSTEM_ERROR_TYPE, systemErrorType: errorType,
});

/**
 * Loadフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SYSTEM_LOADING_FLG = 'COMMON/SET_SYSTEM_LOADING_FLG';

/**
 * Loadフラグ設定
 * @param   {boolean}  systemLodingFLg  ローディングフラグ
 */
export const setSystemLodingFLg = (systemLodingFLg) => ({
  type: SET_SYSTEM_LOADING_FLG, systemLodingFLg,
});

/**
 * Progressフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SYSTEM_PROGRESS_FLG = 'COMMON/SET_SYSTEM_PROGRESS_FLG';

/**
 * Progressフラグ設定
 * ※アップロード、ダウンロードの進捗表示フラグ
 * @param   {boolean}  systemProgressFLg  進捗表示フラグ
 */
export const setSystemProgressFLg = (systemProgressFLg) => ({
  type: SET_SYSTEM_PROGRESS_FLG, systemProgressFLg,
});

/**
 * 進捗率設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PROGRESS_VAL = 'COMMON/SET_PROGRESS_VAL';

/**
 * 進捗率設定
 * @param   {number}  progressVal  進捗率値
 */
export const setProgressVal = (progressVal) => ({
  type: SET_PROGRESS_VAL, progressVal,
});

/**
 * ネットワーク速度設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_NETWORK_SPEED = 'COMMON/SET_NETWORK_SPEED';

/**
 * ネットワーク速度設定
 * @param   {boolean}  networkSpeed  ネットワーク速度値
 */
export const setNetworkSpeed = (networkSpeed) => ({
  type: SET_NETWORK_SPEED, networkSpeed,
});

/**
 * メッセージエリア設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_MESSAGE_AREA = 'COMMON/SET_MESSAGE_AREA';

/**
 * メッセージエリア初期化
 */
export const setInitMessage = () => ({
  type: SET_MESSAGE_AREA, infoMessages: [], warnMessages: [], errorMessages: [],
});
/**
 * INFOメッセージ設定
 * @param   {string[]}  messages  メッセージ配列
 */
export const setInfoMessage = (messages) => ({
  type: SET_MESSAGE_AREA, infoMessages: messages, warnMessages: [], errorMessages: [],
});
/**
 * WARNメッセージ設定
 * @param   {string[]}  messages  メッセージ配列
 */
export const setWarnMessage = (messages) => ({
  type: SET_MESSAGE_AREA, infoMessages: [], warnMessages: messages, errorMessages: [],
});
/**
 * ERRORメッセージ設定
 * @param   {string[]}  messages  メッセージ配列
 */
export const setErrorMessage = (messages) => ({
  type: SET_MESSAGE_AREA, infoMessages: [], warnMessages: [], errorMessages: messages,
});

/**
 * 認証エラーフラグ設定のAction識別文字列
 */
export const SET_AUTH_ERROR_FLG = 'COMMON/SET_AUTH_ERROR_FLG';

/**
  * 認証エラーフラグ
  * @param   {boolean}  authErrorFlg  認証エラーフラグ
  */
export const setAuthErrorFlg = (authErrorFlg) => ({
  type: SET_AUTH_ERROR_FLG, authErrorFlg,
});

/**
  * 多重ログインエラーフラグ設定のAction識別文字列
  * @type    {boolean}  Action識別文字列
  */
export const SET_MULTI_LOGIN_FLG = 'COMMON/SET_MULTI_LOGIN_FLG';

/**
  * 多重ログインエラーフラグ設定
  * @param   {boolean}  multiLoginFlg  多重ログインエラーフラグ
  */
export const setMultiLoginFlg = (multiLoginFlg) => ({
  type: SET_MULTI_LOGIN_FLG, multiLoginFlg,
});

/**
 * ユーザ情報設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_USER_INFO = 'COMMON/SET_USER_INFO';

/**
 * ユーザ情報設定
 * @param   {object}  userInfo  ユーザ情報
 */
export const setUserInfo = (userInfo) => ({ type: SET_USER_INFO, userInfo });

/**
 * 契約ラベル設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CONTRACT_LABEL = 'COMMON/SET_CONTRACT_LABEL';

/**
 * 契約ラベル設定
 * @param   {object}  contractLabel  契約ラベル
 */
export const setContractLabel = (contractLabel) => ({ type: SET_CONTRACT_LABEL, contractLabel });

/**
 * 表示項目設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_ITEM = 'COMMON/SET_DISP_ITEM';

/**
 * 表示項目マスタ設定
 * @param   {object}  dispItem  表示項目マスタ
 */
export const setDispItem = (dispItem) => ({ type: SET_DISP_ITEM, dispItem });

/**
 * 流入区分設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INFLOW_TYPE = 'COMMON/SET_INFLOW_TYPE';

/**
 * 流入区分設定
 * @param   {string}  inflowType 流入区分
 */
export const setInflowType = (inflowType) => ({
  type: SET_INFLOW_TYPE, inflowType,
});

/**
 * パスワード変更POPUP上部に表示するエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_POP_MSG = 'COMMON/SET_ERR_POP_MSG';

/**
 * パスワード変更POPUP上部に表示するエラーメッセージ設定
 * @param   {string}  errPopMsg パスワード変更POPUP上部に表示するエラーメッセージ
 */
export const setErrPopMsg = (errPopMsg) => ({
  type: SET_ERR_POP_MSG, errPopMsg,
});

/**
 * 確認POPUP表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CONFIRM_POP_FLG = 'COMMON/SET_CONFIRM_POP_FLG';

/**
 * 確認POPUP表示フラグ設定
 * @param   {boolean}  confirmPopFlg 確認POPUP表示フラグ
 */
export const setConfirmPopFlg = (confirmPopFlg) => ({
  type: SET_CONFIRM_POP_FLG, confirmPopFlg,
});

/**
 * パスワード変更POPUP表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PASSWORD_POP_FLG = 'COMMON/SET_PASSWORD_POP_FLG';

/**
 * パスワード変更POPUP表示フラグ設定
 * @param   {boolean}  passwordPopFlg パスワード変更POPUP表示フラグ
 */
export const setPasswordPopFlg = (passwordPopFlg) => ({
  type: SET_PASSWORD_POP_FLG, passwordPopFlg,
});

/**
 * POPUPのメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_POP_MESSAGE = 'COMMON/SET_POP_MESSAGE';

/**
 * POPUPのメッセージ設定
 * @param   {string}  popMessage POPUPのメッセージ
 */
export const setPopMessage = (popMessage) => ({
  type: SET_POP_MESSAGE, popMessage,
});

/**
 * 確認フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CONFIRM_FLG = 'COMMON/SET_CONFIRM_FLG';

/**
 * 確認フラグ設定
 * @param   {boolean}  confirmFlg 確認フラグ
 */
export const setConfirmFlg = (confirmFlg) => ({
  type: SET_CONFIRM_FLG, confirmFlg,
});

/**
 * 確認POPUP「はい」選択時の呼出関数設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ONCLICK_YES_FUNCTION = 'COMMON/SET_ONCLICK_YES_FUNCTION';

/**
 * 確認POPUP「はい」選択時の呼出関数設定
 * @param   {string}  onClickYesFunction 確認POPUP「はい」選択時の呼出関数
 */
export const setOnClickYesFunction = (onClickYesFunction) => ({
  type: SET_ONCLICK_YES_FUNCTION, onClickYesFunction,
});

/**
 * 確認POPUP「いいえ」選択時の呼出関数設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ONCLICK_NO_FUNCTION = 'COMMON/SET_ONCLICK_NO_FUNCTION';

/**
 * 確認POPUP「いいえ」選択時の呼出関数設定
 * @param   {string}  onClickNoFunction 確認POPUP「いいえ」選択時の呼出関数
 */
export const setOnClickNoFunction = (onClickNoFunction) => ({
  type: SET_ONCLICK_NO_FUNCTION, onClickNoFunction,
});

/**
 * ユーザ認証処理
 * @param   {string}  userId   ユーザID
 * @param   {string}  password  パスワード
 */
export const authenticate = (userId, password) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    user_id: userId,
    password,
  };
  // 認証APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.AUTH_USER, o);
  return ret.result === 0;
};

/**
 * ユーザ情報の取得
 * @returns {object}  ユーザ情報
 */
export const getUserInfo = () => async (dispatch) => {
  // 認証APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_USER);
  if (ret.result === 0) dispatch(setUserInfo(ret.response));
  return ret.response;
};

/**
 * 契約ラベル情報の取得
 * @returns {object}  契約ラベル
 */
export const getContractLabel = () => async (dispatch) => {
  // 認証APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_CONTRACT_LABEL);
  if (ret.result === 0) dispatch(setContractLabel(ret.response));
  return ret.response;
};

/**
 * 表示項目マスタの取得
 * @returns {object}  表示項目
 */
export const getDispItem = () => async (dispatch) => {
  // 認証APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_DISP_ITEM);
  if (ret.result === 0) dispatch(setDispItem(ret.response));
  return ret.response;
};

/**
 * CSRFトークンの取得
 */
export const getCsrfToken = () => async (dispatch) => {
  // CSRFトークンAPIへリクエスト
  await requestApi(dispatch, API_END_POINT.GET_TOKEN);
};

/**
 * ユーザ認証解除
 */
export const disAuthenticate = () => async (dispatch) => {
  // 認証解除APIへリクエスト
  await requestApi(dispatch, API_END_POINT.LOGOUT);
  dispatch(setUserInfo(null));
};

/**
 * 地域マスタ情報の取得
 * @returns {object}  地域マスタ情報
 */
export const getAreaMaster = () => async (dispatch) => {
  // 地域マスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_AREA);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * 業種マスタ情報の取得
 * @param   {string}  targetDivision  業種分類識別コード
 * @param   {string}  divisionCode  親業種コード
 * @returns {object}  業種マスタ情報
 */
export const getIndustryMaster = (targetDivision, divisionCode) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    target_division: targetDivision,
    division_code: divisionCode,
  };
  // 業種マスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_INDUSTRY, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * 住所マスタ情報の取得
 * @param   {string}  prefecturesCode  都道府県コード
 * @returns {object}  住所マスタ情報
 */
export const getAddressMaster = (prefecturesCode) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    prefectures_code: prefecturesCode,
  };
  // 住所マスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_ADDRESS, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * コードマスタ取得
 * @param   {string}  shubetsuCode 種別コード
 * @returns {object}  コードマスタ
 */
export const getCodeMaster = (shubetsuCode) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    shbtcd: shubetsuCode,
  };
  // コードマスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_GYOTAI_LIST, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * パスワード有効期限チェックAPI
 */
export const checkExpirationDate = () => async (dispatch) => {
  // パスワード有効期限チェックAPIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.CHECK_PASSWORD_EXPIRATION_DATE);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return ret;
  }
  // 正常に終了した場合はtrueを返す
  return ret;
};

/**
 * 権限マスタ取得
 * @returns {object}  権限マスタ情報
 */
export const getRoleMaster = () => async (dispatch) => {
  // 権限マスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_ROLE);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return ret.response;
  }
  // 正常の場合は権限マスタ検索結果を返す
  return ret.response;
};

/**
 * パスワード更新API
 * @param {string} oldPassword   元のパスワード
 * @param {string} newPassword   変更後のパスワード
 */
export const updatePassword = (oldPassword, newPassword) => async (dispatch) => {
  // リクエストパラメータの設定
  const o = {
    old_password: oldPassword,
    new_password: newPassword,
  };
  // パスワード変更API実行
  const ret = await requestApi(dispatch, API_END_POINT.UPDATE_PASSWORD, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrPopMsg(ret.response));
    return false;
  }
  // 正常に終了した場合はtrueを返す
  return true;
};
